import { Controller } from "../vendor/stimulus.js";

export default class extends Controller {
  static targets = ["menuButton"];

  connect() {
    this.boundDocumentHandler = this.handleDocumentClick.bind(this);
    this.boundKeydownHandler = this.handleKeydown.bind(this);
    document.addEventListener("click", this.boundDocumentHandler);
    document.addEventListener("keydown", this.boundKeydownHandler);
    this.updateMenuState(this.isOpen());
  }

  disconnect() {
    document.removeEventListener("click", this.boundDocumentHandler);
    document.removeEventListener("keydown", this.boundKeydownHandler);
  }

  toggle(event) {
    event?.preventDefault?.();
    const open = this.element.classList.toggle("menu-open");
    this.updateMenuState(open);
  }

  close() {
    if (!this.isOpen()) return;
    this.element.classList.remove("menu-open");
    this.updateMenuState(false);
  }

  handleDocumentClick(event) {
    if (!this.isOpen()) return;
    if (this.element.contains(event.target)) return;
    this.close();
  }

  handleKeydown(event) {
    if (event.key !== "Escape") return;
    this.close();
  }

  handleMenuClick(event) {
    const trigger = event.target?.closest?.("a, button");
    if (!trigger) return;
    this.close();
  }

  isOpen() {
    return this.element.classList.contains("menu-open");
  }

  updateMenuState(isOpen) {
    if (this.hasMenuButtonTarget) {
      this.menuButtonTarget.setAttribute("aria-expanded", String(isOpen));
    }
  }
}
